// Popup.tsx
import React, { useContext, useEffect, useState } from "react";
// import InputsDropdown from "../../Common/InputsDropdown";
import { Controller, useForm } from "react-hook-form";
import deletemodelpopup from "../../assets/task/deletemodelpopup.svg";
// import DateSelector from "../../Common/DateSelector";
// import InputsNew from "../../Common/InputsNew";
// import { useHistory } from "react-router-dom";
// import { UserContext } from "../../../providers/MainContext";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import clockOuticon from "../../assets/task/login_svgrepo-com.svg";

import {
    ApolloError,
    useLazyQuery,
    useMutation,
    useQuery,
} from "@apollo/client";
// import {
//     EMPLOYEE_BY_AGENCY_ID,
// } from "../../../api/query";
// import { CREATE_TASK_MUTATION } from "../../../api/mutation";
//@ts-ignore
// import { employeeUrl, clientUrl } from "../../../providers/apollo-client";
// import { showError, showSuccess } from "../../Common/ToastNotification";
import { format, parseISO } from "date-fns";
import { useAuth } from "../../context/AuthContext";
import { CREATE_CLOCK_IN_OUT, CREATE_TASK_MUTATION, CREATE_UPDATE_TODO } from "../../api/mutation";
import { showError, showSuccess } from "../common/ToastNotification";
import SearchableInputsDropdown from "../common/SearchableDropdown";
import DateSelector from "../common/DateSelector";
import InputsNew from "../common/InputsNew";
import { useNavigate } from "react-router-dom";
import { EMPLOYEES_BY_AGENCY_ID } from "../../api/query";
import Loader from "../common/Loader";
// import SearchableInputsDropdown from "../../Common/SearchableDropdown";

interface PopupProps {
    isOpen: boolean;
    onClose: () => void;
    refetch: any;
    meetingID: any
}

interface AddTodo {
    title: string;
    description?: string;
    dueDate: string;
    assignedToID: string;
    assignedToName: string;
}

// Validation schema
const addTodoSchema = yup.object().shape({
    title: yup.string()
        .test('not-only-whitespace', 'Please add a valid Title', value => !value || value.trim().length > 0)
        .required('This field is required'),
    description: yup.string().nullable(),
    dueDate: yup.string().required("This field is required"),
    assignedToID: yup.string().required("This field is required"),
    assignedToName: yup.string().required("This field is required"),
});


const AddTodoPopup: React.FC<PopupProps> = ({ isOpen, onClose, refetch, meetingID }) => {
    const navigate = useNavigate()
    const { userInfo } = useAuth()
    const employeeID = userInfo?.employee_id || '';
    const organizationID = userInfo?.agencies?.id || '';

    const [assignedMemberOptions, setAssignedMemberOptions] = useState<{ key: string; name: string }[]>([]);

    //api
    const [
        getEmployeesByAgencyID,
        { data: employeesData, loading: employeesDataLoading },
    ] = useLazyQuery(EMPLOYEES_BY_AGENCY_ID, {
        fetchPolicy: 'no-cache'
    });

    const [createUpdateToDo, { loading: createUpdateToDoLoading }] = useMutation(CREATE_UPDATE_TODO, {
        fetchPolicy: 'no-cache',
    })

    const {
        control,
        register,
        setValue,
        trigger,
        handleSubmit,
        watch,
        reset,
        setFocus,
        formState: { errors },
    } = useForm<any>({
        resolver: yupResolver(addTodoSchema),
    });

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("coverflow_hidden_scoll_bdy");

            return () => {
                document.body.classList.remove("coverflow_hidden_scoll_bdy");
            };
        }
    }, [isOpen]);

    useEffect(() => {
        if (organizationID) {
            getEmployeesByAgencyID({
                variables: {
                    agency_id: parseInt(organizationID)
                }
            });
        }
    }, [organizationID])

    useEffect(() => {
        if (employeesData && employeesData.employees_by_agency_id) {
            const employeeOptions = employeesData?.employees_by_agency_id?.employees?.map((emp: any) => ({
                key: emp.employee_id,
                name: `${emp.first_name} ${emp.last_name}`
            }));
            setAssignedMemberOptions(employeeOptions);
        }
    }, [employeesData])

    const handleCancel = () => {
        onClose();
        // reset({
        //     clientdrop: '',
        //     date: null,
        //     taskName: ''
        // });
    };

    //watch
    const watchAssignedMember: string = watch('assignedToName')

    function handleSelectAssignee(key: string, name: string): void {
        setValue('assignedToID', key)
        setValue('assignedToName', name)
        trigger('assignedToName')
    }

    if (!isOpen) return null;

    async function onSubmit(data: AddTodo) {
        const input: any = {
            title: data.title,
            description: data.description,
            todo_assigned_user: parseInt(data.assignedToID),
            due_date: `${data.dueDate}T00:00:00`,
            meeting_id: parseInt(meetingID),
        }
        if (data.description?.trim()) input.description = data.description.trim();

        try {
            const response = await createUpdateToDo({
                variables: {
                    created_by: parseInt(employeeID),
                    input: input
                }
            });
            if (response.data.create_update_todo.status_code === 200) {
                showSuccess(response.data.create_update_todo.message)
                refetch?.()
                onClose()
            }
            if (response.data.create_update_todo.status_code === 400) {
                showError(response.data.create_update_todo.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    return (
        <>
            <div id="model-main-blg" onClick={(e) => e.stopPropagation()}>
                <div id="inner_loader_dv">
                    {/* <div className="w-[622px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 schedularaddtask_main"> */}
                    <div className=" max-w-[575px] flex flex-row items-start justify-start w-[100%] z-[1] mq825:max-w-full m-4 schedularaddtask_main">
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            className="m-0 flex-1 rounded-radius-radius-lg todo-item-model bg-white border-[1px] border-solid border-surface-border flex flex-col items-center justify-start p-8 mq575:p-3 box-border gap-[23.8px] max-w-full mq825:pt-[21px] mq825:pb-[21px] mq825:box-border"
                        >
                            <div className="relative w-full" onClick={handleCancel}>
                                <img
                                    src={deletemodelpopup}
                                    alt=""
                                    className="cursor-pointer pr-0  mq575:pr-0 mq575:pt-0 w-5 h-5 absolute right-0 top-[-5px]  mq575:top-0 mq575:w-3 mq575:h-3 dark-white-img "
                                    style={{}}
                                    onClick={handleCancel} />
                            </div>
                            <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-0 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                              <div className="grid w-full">
                                    <InputsNew
                                        contentPlaceholder="Title"
                                        label="Title*"
                                        type="text"
                                        register={register('title')}
                                        errorMessage={errors.title}
                                    />
                                </div>
                                <div className="grid w-full">
                                    <InputsNew
                                        contentPlaceholder="Description"
                                        label="Description"
                                        type="textarea"
                                        register={register('description')}
                                        errorMessage={errors.description}
                                    />
                                </div>
                                <div className="grid w-full">
                                    <Controller
                                        name="dueDate"
                                        control={control}
                                        render={({ field }) => (
                                            <DateSelector
                                                label="Due Date*"
                                                selectedDate={field.value}
                                                onChange={(date: any) => {
                                                    field.onChange(date);
                                                    setValue('dueDate', date);
                                                    trigger('dueDate');
                                                }}
                                                error={errors.dueDate?.message}
                                                nothideParsedValue={true}
                                                minDate={new Date()}
                                            />
                                        )}
                                    />
                                </div>
                                 <div className="grid w-full">
                                    <SearchableInputsDropdown
                                        label="Assign To*"
                                        initialValue={watchAssignedMember}
                                        placeHolder="Select Member"
                                        options={assignedMemberOptions}
                                        onSelect={handleSelectAssignee}
                                        errorMessage={errors?.assignedToName}
                                    />
                                </div>

                                <div className="self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq950:box-border mq1425:flex-wrap  mq1425:box-border mq450:box-border">
                                    <button className="cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] btn-text-purple mq575:py-[12.5px] mq575:px-[25px] rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                                        // onClick={handleGoBack}
                                        type="button"
                                        onClick={onClose}
                                    >
                                        <div className="relative text-sm font-body-xs-semi-bold  dark:text-white text-center inline-block">
                                            Cancel
                                        </div>
                                    </button>
                                    <button className={`cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue`}
                                        // disabled={(err || careDelErr) !== ''}
                                        type="submit"
                                    >
                                        <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">
                                            Save
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {(employeesDataLoading || createUpdateToDoLoading) && (
                <Loader />
            )}
        </>
    );
};

export default AddTodoPopup;
